require('./../semantic-ui_excluding_dropdown');
var Basket = require('./basket');

//TODO переписать, неподдерживаемо
_controlPayment();

function _controlPayment() {

    jQuery("input[name='payment_method']").on('change',
        function () {
            if (this.checked) {
                jQuery("li.payment-method-container[payment-method='" + this.value + "'] .payment-comment").removeClass('hidden');
                jQuery("li.payment-method-container[payment-method!='" + this.value + "'] .payment-comment").addClass('hidden');
            }
        });

    handleCheckoutSteps();
    handleCityInput();

    //first tab has number one. Used to navigate with 'back'
    window.location.hash = '1';

    /***** Работа с шагами оформления *****/
    function handleCheckoutSteps() {
        var
            stepTabs = $('.checkout-steps_step'),
            nextButton = $('.next-step'),
            currentDeliveryTypeId;

        //listen to inputs to activate tabs when possible
        listenInput();

        //
        console.log(stepTabs);
        window.onhashchange = function(){
            var h = window.location.hash.substring(1);
            goToTab(h);
        };

        //tab click handler
        stepTabs.each(function (i, tab) {
            $(tab).on('click', function () {
                var tab = $(this);

                //we can not switch to disabled tab
                if (!tab.hasClass('disabled')) {
                    var tabNumber = tab.data('step');
                    goToTab(tabNumber);
                } else {
                    whyStepIsUnavailable(tab);
                }
            });
        });

        //next step button handler
        nextButton.each(function (i, button) {
            $(button).on('click', function () {
                var btn = $(this),
                    inputs,
                    currentStepNumber = btn.parent('.step-body').data('step'),
                    checkPassed = true;

                switch (currentStepNumber) {
                    case 1:
                        inputs = btn.parent('.step-body').find('input')
                        break;
                    case 2:
                        var delivery_method = btn.parent('.step-body').find('input[name="delivery_method"]:checked').val();
                        if(delivery_method == 6)
                            inputs = $('#i_city');
                        break;
                    default:
                }

                if(inputs)
                    inputs.each(function () {
                        var input = $(this);
                        processRequiredField(input)
                    }).promise().done(function () {
                        if (checkPassed)
                            goToTab(++currentStepNumber);
                    });
                else {
                    goToTab(++currentStepNumber);
                }

                function processRequiredField(input) {
                    if (input.hasAttr('required') && !input.val()) {
                        checkPassed = false;
                        $('html, body').animate({
                            scrollTop: input.offset().top - 200
                        });
                        input.popup('show');
                    }
                }
            })
        });

        /**
         * Watches what user does with inputs in tab steps and decides whether to allow next step or not
         */
        function listenInput() {

            /**
             * @param n
             * @constructor
             */
            function Step(n) {
                this.n = n;
                this.assignedTab = $('.checkout-steps_step[data-step=' + n + ']');
                this.disableNext = function () {
                    var i = this.n + 1;
                    while(true) {
                        var next = $('.checkout-steps_step[data-step=' + i + ']');
                        if (!next.length)
                            break;

                        next.addClass('disabled');
                        i++;
                    }
                    $('div[data-step="' + this.n + '"').find('.next-step').hide();
                };

                this.enableNext = function (step) {
                    step.removeClass('disabled');
                    $('div[data-step="' + this.n + '"').find('.next-step').show();
                }
            }

            //iterate all tab bodies
            $('.step-body').each(function (i, tab) {
                var tab = $(tab),
                    n = tab.data('step'),
                    currentStep = new Step(n),
                    nNext = n + 1,
                    nextStep = $('.checkout-steps_step[data-step=' + nNext + ']'),
                    requiredInputs;

                if (!nextStep)
                    return false;

                //decide if enable next step or not
                switch (n) {
                    case 1:
                        requiredInputs = tab.find('input[required="required"]');
                        $(requiredInputs).each(function (i, input) {
                            $(input).keyup(function () {
                                var allFilled = true;
                                requiredInputs.each(function (i, input) {
                                    if (!$(input).val())
                                        allFilled = false;
                                });
                                checkIfNextToBeEnabled(allFilled);
                            })
                        });
                        break;
                    case 2:
                        //if delivery method has been chosen
                        $('input:radio[name="delivery_method"]').change(function () {
                            currentDeliveryTypeId = $(this).data('deliveryTypeId');
                            if (currentDeliveryTypeId == 1)
                                checkIfNextToBeEnabled(true);
                            else
                                checkInput();
                        });

                        //look for text inputs
                        var inputs = tab.find('input');
                        $(inputs).each(function (i, input) {
                            $(input).keyup(function () {
                                checkInput();
                            })
                        });

                        /**
                         * Check text in delivery tab and make next tab available if possible
                         */
                        function checkInput() {
                            switch (currentDeliveryTypeId) {
                                case 2:
                                    if ($('#i_city').val())
                                        checkIfNextToBeEnabled(true);
                                    else
                                        checkIfNextToBeEnabled();
                                    break;
                                case 3:
                                    if ($('#i_city').val() && ($('input[name="address_1"]').val()))
                                        checkIfNextToBeEnabled(true);
                                    else
                                        checkIfNextToBeEnabled();
                                    break;
                                default:
                                    checkIfNextToBeEnabled(true);
                                    break;
                            }
                        }
                        break;
                    default :
                        return false;
                }

                /**
                 * Marks next tab as active/disabled
                 * @param {boolean} [allFilled]
                 */
                function checkIfNextToBeEnabled(allFilled) {
                    if (allFilled)
                        currentStep.enableNext(nextStep);
                    else {
                        currentStep.disableNext();
                    }
                }
            })
        }

        /**
         * Get info message about data has to be inserted to be able to switch to the step
         * @param {jQuery} tab
         */
        function whyStepIsUnavailable(tab) {
            var reasons = {
                    'Данные': [],
                    'Доставка': [],
                    'Оплата': []
                },
                n = tab.data('step'),
                currentStepContainer = $('.step-body:visible');

            scanEmptyRequiredFields();

            switch (n) {
                case 2:
                    break;
                case 3:
                    var checked_radios = $('input[name="delivery_method"][type="radio"]:checked');
                    if (!checked_radios.length)
                        reasons['Доставка'].push('Выберите метод доставки');
                    else {
                        switch (currentDeliveryTypeId) {
                            case 2:
                                if (!$('#i_city').val())
                                    reasons['Доставка'].push('Укажите населенный пункт');
                                break;
                            case 3:
                                if (!$('#i_city').val() && !($('input[name="address_1"]').val()))
                                    reasons['Доставка'].push('Укажите населенный пункт и адрес');
                                break;
                            default:
                                break;
                        }
                    }
                    break;
            }

            /**
             * Looks for required but empty input fields
             */
            function scanEmptyRequiredFields() {
                currentStepContainer.each(function (i_container, container) {       //перебираем видимые контейнеры с полями ввода (это всегда один)
                    var containerName;
                    switch ($(container).data('step')) {
                        case 1:
                            containerName = 'Данные';
                            break;
                        case 2:
                            containerName = 'Доставка';
                            break;
                        case 3:
                            containerName = 'Оплата';
                            break;
                    }

                    $(container).find('input[required="required"]').each(function (i, input) {
                        var $input = $(input),
                            input_val = $input.val(),
                            label,
                            input_name;

                        if (!input_val) {
                            input_name = $("label[for='" + $input.attr('id') + "']").text();
                            reasons[containerName].push("Не заполнено поле " + input_name);
                        }
                    })
                });
            }

            //на основе объекта reasons здесь генерируется попап с причинами, почему нельзя переключить вкладку
            tab.popup({
                on: 'click',
                html: (function () {
                    var content = '<p>Проверьте параметры</p>';
                    for (var k in reasons) {
                        var tab_reason = reasons[k];
                        if (tab_reason.length) {
                            content += '<div class="reason">';
                            content += '<span class="reason__header">' + k + ':</span><br>';
                            for (var i in tab_reason) {
                                content += '<span class="reason__body">' + tab_reason[i].replace('*', '') + '</span>';
                            }
                            content += '</div>';
                        }
                    }
                    return content;
                })(),
                onHidden: function () {
                    tab.popup('destroy');
                }
            }).popup('show');
        }


        /**
         * Changes tab
         * @param number tab number
         */
        function goToTab(number) {
            window.location.hash = number;

            var targetStepBody = $('.step-body[data-step=' + number + ']');

            $('.checkout-steps_step.active').removeClass('active');
            $('.checkout-steps_step[data-step=' + number + ']').addClass('active').removeClass('disabled');

            $('.step-body').hide();
            targetStepBody.show();
            hideNextButton(targetStepBody);

            window.scrollTo(0, document.querySelector('article.post > .ui.grid').getBoundingClientRect().top + document.body.scrollTop);
        }

        /**
         * Hides next button if there are radio buttons and none of them are checked
         * Operates different pieces of the form shouldn't be displayed before some actions have happened
         * @param stepBody
         */
        function hideNextButton(stepBody) {
            var nextButton = stepBody.find('.next-step'),
                deliveryVariants = stepBody.find('.delivery-variants'),
                deliveryOptions = stepBody.find('.delivery-options'),
                shippingAdress = stepBody.find('.shipping_address');

            //when there're not selected radios (in case they exist) we should hide next button.
            // One radio is choosen by default so we wait for 2 radios selected
            if (stepBody.find('input:radio:visible').length && stepBody.find('input:checked').length < 2) {
                nextButton.hide();
                /*deliveryVariants.hide();
                deliveryOptions.hide();*/
                shippingAdress.hide();

                stepBody.find('input:radio').each(function (i, el) {
                    $(el).on('click', function () {
                        nextButton.show();
                        /*deliveryVariants.show();
                        deliveryOptions.show();*/
                        shippingAdress.show();
                    })
                })
            }
        }
    }

    /***** Работа с полем ввода города *****/
    /***** Если человек меняет Москву в текстовом поле, способ доставки, меняем на Доставку по России *****/
    function handleCityInput() {

        var
            $cityField = jQuery('#i_city'),
            cityField = $cityField[0],
            eventName = 'keyup.moscowDependantDeliveryType';

        cityField.addEventListener(eventName, function (e) {        //слушаем нативное событие из vue
            processCityInput(e.inputValue);
        });

        $cityField.on(eventName, function (e) {                     //слушаем jquery-событие
            processCityInput(e.currentTarget.value);
        });

        /**
         * Acts when city input changed (nevermind by typing or vue autocomplete plugin
         * @param string
         */
        function processCityInput(string) {
            var inputIsMoscowLike = compareToMoscow(string),
                currentDeliveryMethod = jQuery("input[name='delivery_method']:checked"),
                currentDeliveryMethodId = jQuery(currentDeliveryMethod).val();

            if (currentDeliveryMethodId == 4 && !inputIsMoscowLike) {
                chooseDeliveryMethod(6);
            } else if (currentDeliveryMethodId == 6 && inputIsMoscowLike) {
                chooseDeliveryMethod(4)
            }

            /**
             * Choose delivery method by id
             * @param deliveryMethodId
             */
            function chooseDeliveryMethod(deliveryMethodId) {
                $('input[name="delivery_method"][value="' + deliveryMethodId + '"]').trigger('click');
            }

            /**
             * Checks whether the string is a substring of word 'Москва' and not ''
             * @param string
             * @returns {boolean}
             */
            function compareToMoscow(string) {
                var capitalised = string.charAt(0).toUpperCase() + string.slice(1);
                return capitalised == 'Москва' || capitalised == 'Москва г' || capitalised == 'Москва ';
            }
        }
    }
}
// todo: Возможно, посмотреть на селекторы в плане их подробности: не просто .delivery-cost, а #review ... .delivery-cost
var selectors = {
    deliveryMethodsInputs: 'input[type="radio"][name="delivery_method"]',
    deliveryVariants: 'input[type="radio"][name="delivery_variant"], .grouped-referenced-to-table-delivery-variants .delivery-variant .item',
    deliveryOptions: '.delivery-options input[type="checkbox"]',
    deliveryLabel: '.shipping .delivery-label',
    deliveryVariantCostAdditionalInfo: '.shipping .delivery-variant-cost-additional-info',
    deliveryCost: '.delivery-cost',
    deliveryCostLoader: '.delivery-cost-loader',
    deliveryCostInput: 'input[name="delivery_cost"]',
    orderTotalContainer: '.total .amount',
    stepRightInfo1: '.step-info__1',
    stepRightInfo2: '.step-info__2',
    cityField: '#i_city',
    firstAddressFieldLabelSpan: 'label[for="shipping_address_1"] span',
    displayedDependentOnDeliveryType: '.displayed-dependent-on-delivery-type',
    deliveryInputs: '.delivery-input',
    inputs: 'input, textarea, select',
    paymentMethodContainer: 'li.payment-method-container',
    paymentMethodInput: 'input[name="payment_method"]'
};

var $deliveryLabel = $(selectors.deliveryLabel),
    $deliveryCost = $(selectors.deliveryCost),
    $deliveryCostLoader = $(selectors.deliveryCostLoader),
    $deliveryCostInput = $(selectors.deliveryCostInput),
    $orderTotalContainer = $(selectors.orderTotalContainer),
    $cityField = $(selectors.cityField),
    $firstAddressFieldLabelSpan = $(selectors.firstAddressFieldLabelSpan),
    $deliveryVariantCostAdditionalInfo = $(selectors.deliveryVariantCostAdditionalInfo),
    // Показан ли соответствующий выбору способа получения правый информационный блок
    stepRightInfoShown = false;

// Нажатие на способ получения
$(selectors.deliveryMethodsInputs).on('click', function () {
    var $deliveryMethod = $(this),
        deliveryMethodId = $deliveryMethod.val(),
        deliveryTypeId = $deliveryMethod.data('deliveryTypeId'),
        $deliveryMethodContainer = $('.delivery-method-container[delivery-method=' + deliveryMethodId + ']'),
        $firstDeliveryVariant = $deliveryMethodContainer.find(selectors.deliveryVariants).first();

    // Показываю текущий способ получения, скрываю прочие
    $deliveryMethodContainer.show();
    $('.delivery-method-container[delivery-method!=' + deliveryMethodId + ']').hide();

    // Если не показан, показываю соответствующий этапу выбора способа получения правый информационный блок
    if (!stepRightInfoShown) {
        $(selectors.stepRightInfo1).addClass('hidden');
        $(selectors.stepRightInfo2).removeClass('hidden');
        stepRightInfoShown = true;
    }
    switch (deliveryTypeId) {
        case 1:
            $deliveryLabel.text('Самовывоз');
            break;
        case 2:
            $deliveryLabel.text('Доставка');
            $cityField.val('Москва');
            $firstAddressFieldLabelSpan.text('Рабочий адрес');
            break;
        case 3:
            $deliveryLabel.text('Доставка');
            $firstAddressFieldLabelSpan.text('Адрес');
            break;
    }

    //  Показываю поля текущего способа доставки и скрываю прочих,
    //  соответственно делаю поля передаваемыми и непередаваемыми
    $(selectors.displayedDependentOnDeliveryType).each(
        function(){
            var $this = $(this),
                deliveryTypes = $this.data('deliveryTypes');
            if (deliveryTypes instanceof Array
                    && deliveryTypes.indexOf(deliveryTypeId) < 0)
                $this.addClass('hidden');
            else
                $this.removeClass('hidden');
        }
    );
    $(selectors.deliveryInputs).each(
        function () {
            var $this = $(this),
                $input,
                deliveryTypes;
                // С указанным классом может быть непосредственно поле, а может быть контейнер, содержащий поле
                if ($this.is(selectors.inputs)) {
                    $input = $this;
                    deliveryTypes = $this.data('deliveryTypes');
                } else {
                    $input = $this.find(selectors.inputs);
                    // Способы получения могут быть указаны в самом поле, а могут быть указаны в контейнере
                    deliveryTypes = $input.data('deliveryTypes') || $this.data('deliveryTypes');
                }
            if ($input.length) {
                if (deliveryTypes instanceof Array
                        && deliveryTypes.indexOf(deliveryTypeId) < 0) {
                    $input.prop('disabled', true);
                }
                else {
                    $input.prop('disabled', false);
                }
            }
        }
    );

    // Работаю со способами оплаты
    var paymentMethodsOfCurrentDeliveryMethod,
        currentPaymentMethodId,
        thereIsDefaultPaymentMethod = false,
        $defaultPaymentMethod;
    if (paymentMethodToDeliveryMethod[deliveryMethodId]
            && (paymentMethodsOfCurrentDeliveryMethod = Object.keys(paymentMethodToDeliveryMethod[deliveryMethodId])).length) {
        $(selectors.paymentMethodContainer).each(function () {
            var $this = $(this);
            if ($.inArray(currentPaymentMethodId = $this.attr('payment-method'), paymentMethodsOfCurrentDeliveryMethod) > -1) {
                $this.removeClass('hidden');
                if (paymentMethodToDeliveryMethod[deliveryMethodId][currentPaymentMethodId].isDefault) {
                    $this.find(selectors.paymentMethodInput).prop('checked', true);
                    thereIsDefaultPaymentMethod = true;
                }
            }
            else {
                $this.addClass('hidden');
            }
        });
    } else {
        $(selectors.paymentMethodContainer).removeClass('hidden');
        if (($defaultPaymentMethod = $(selectors.paymentMethodContainer + "[is-default='1']")).length) {
            $defaultPaymentMethod.find(selectors.paymentMethodInput).prop('checked', true);
            thereIsDefaultPaymentMethod = true;
        }
    }
    if (!thereIsDefaultPaymentMethod) {
        $(selectors.paymentMethodContainer + ":not(.hidden)").first().find(selectors.paymentMethodInput).prop('checked', true);
    }
    $(selectors.paymentMethodInput + ":checked").trigger('change');

    // Нажимаю на первый вариант получения или работаю с самим способом
    if ($firstDeliveryVariant.length) {
        $firstDeliveryVariant.trigger('click');
    } else {
        processDeliveryCost.apply(this);
    }
});

// Нажатие на вариант получения
$(selectors.deliveryVariants).on('click', processDeliveryCost);

/**
 * Функция определяет и устанаваливает стоимость получения
 */
function processDeliveryCost(){
    var $deliveryVariant = $(this),
        deliveryVariantCost = $deliveryVariant.data('cost'),
        deliveryVariantCostAdditionalInfo = $deliveryVariant.data('costAdditionalInfo'),
        deliveryCost = null;
    // Может буть указана дополнительная информация о стоимости
    if (deliveryVariantCostAdditionalInfo) {
        $deliveryVariantCostAdditionalInfo[0].dataset['html'] = deliveryVariantCostAdditionalInfo;
        $deliveryVariantCostAdditionalInfo.show();
    } else {
        $deliveryVariantCostAdditionalInfo.hide();
        $deliveryVariantCostAdditionalInfo[0].dataset['html'] = '';
    }
    // Может быть непосредственно указанна стоимость для выбранного варианта
    if (deliveryVariantCost !== undefined && deliveryVariantCost !== '') {
        deliveryCost = deliveryVariantCost;
    }
    // Может быть определена зависимость стоимости от суммы заказа
    else {
        var deliveryCostDependenceOnOrderSum = $deliveryVariant.data('costDependenceOnOrderSum');
        if (deliveryCostDependenceOnOrderSum) {
            var orderTotal = +$orderTotalContainer.data('price');
            for (var dependenceIndex in deliveryCostDependenceOnOrderSum) {
                if (orderTotal >= deliveryCostDependenceOnOrderSum[dependenceIndex].order_sum_min
                        && (deliveryCostDependenceOnOrderSum[dependenceIndex].order_sum_max === null || orderTotal <= deliveryCostDependenceOnOrderSum[dependenceIndex].order_sum_max)) {
                    deliveryCost = deliveryCostDependenceOnOrderSum[dependenceIndex].cost;
                }
            }
        }
    }
    if (deliveryCost === null) {
        // Если не удалось определить стоимость, пытаюсь обратиться к серверу
        var calculateDeliveryCostUrl = $deliveryVariant.data('calculateDeliveryCostUrl');
        if (calculateDeliveryCostUrl) {
            // Отработать индикатор загрузки
            $deliveryCost.hide();
            $deliveryCostLoader.addClass('active');
            var requestData = {},
                dataForRequest = $deliveryVariant.data('calculateDeliveryCostDataForRequestAsJsonArray');
            for (var parameterName in dataForRequest) {
                requestData[parameterName] = eval(dataForRequest[parameterName]);
            }
            $.ajax({
                url: calculateDeliveryCostUrl,
                data: requestData,
                method: $deliveryVariant.data('calculateDeliveryCostRequestMethod'),
                complete: function (xhr) {
                    setDeliveryCost(JSON.parse(xhr.responseText));
                    $deliveryCostLoader.removeClass('active');
                    $deliveryCost.show();
                }
            });
        } else {
            setDeliveryCost(deliveryCost);
        }
    } else {
        setDeliveryCost(deliveryCost);
    }
}

/**
 * Функция устанавливает стоимость получения
 * @param {(number|null)} cost
 */
function setDeliveryCost(cost)
{
    if (cost !== null) {
        $deliveryCost.text(Basket.getPriceFormatted(cost));
        $orderTotalContainer.text(Basket.getPriceFormatted(+$orderTotalContainer.data('price') + +cost));
    } else {
        $deliveryCost.text('расчетная стоимость');
        $orderTotalContainer.text(Basket.getPriceFormatted($orderTotalContainer.data('price')) + ' + ' + $deliveryLabel.text().toLowerCase());
    }
    $deliveryCostInput.val(cost);
}


// WEBPACK FOOTER //
// ./assets/javascript/checkout/oformpage.js